import DefaultLayout from '@/components/layout/DefaultLayout.tsx';
import { Card, ErrorBlock } from 'antd-mobile';
import useAjax from '@/hooks/useAjax.ts';
import dayjs from 'dayjs';
import { PATH_AI_CHAT } from '@/router/routes.ts';
import { useTitle } from 'ahooks';
import { IChatHistoryItem } from '@/types/.fetch.ts';

export default function AiChatHistory() {
    useTitle('Ai智答会话历史');

    // 获取引导信息
    const { response: historyList } = useAjax<IChatHistoryItem[]>(
        {
            url: '/app/ai/session/list?size=20',
        },
        {
            defaultValue: [],
        },
    );

    const handleItemClick = (itemData: IChatHistoryItem) => {
        const { sessionId } = itemData;
        window.location.replace(`${PATH_AI_CHAT}?sessionId=${sessionId}`);
    };

    return (
        <DefaultLayout>
            <div className="flex w-full flex-col gap-3 px-3 py-5">
                {historyList?.length <= 0 && <ErrorBlock title="暂无历史会话" status="empty" />}
                {historyList?.map((item) => {
                    return (
                        <Card key={item.sessionId} onClick={() => handleItemClick(item)}>
                            <p className="mb-3 line-clamp-1 text-sm font-medium">{item?.title}</p>
                            <div className="flex justify-between">
                                <div className="flex items-center gap-x-2 text-xs font-medium">
                                    <img src="/assets/images/icon_aichat_history.png" className="w-4" alt="" />
                                    {item?.chatCount || 0}
                                </div>
                                <div className="text-xs text-secondary">
                                    {dayjs(item?.createTime).format('YYYY-MM-DD HH:mm:ss')}
                                </div>
                            </div>
                        </Card>
                    );
                })}
            </div>
        </DefaultLayout>
    );
}
